import * as z from 'zod';
import { MaterialMeasurementFormValues } from './types';
import { validateFloat } from '@utils/formHelpers';
import { schema } from '@forms/helpers';

export const formSchema = z
  .object({
    final: schema.boolean(),
    optionsAttributes: z.array(
      z.object({
        id: schema.input(),
        estimatedQuantity: schema.input(),
        finalQuantity: schema.input(),
        includeEstimated: schema.boolean(),
        valueType: schema.input(),
        required: schema.boolean(),
      }),
    ),
  })
  .superRefine(({ final, optionsAttributes }, ctx) => {
    optionsAttributes.forEach(
      ({ valueType, estimatedQuantity, includeEstimated, finalQuantity, required }, i) => {
        if (!required) return;
        if (
          valueType === 'text'
            ? includeEstimated
              ? !estimatedQuantity
              : false
            : includeEstimated
              ? !validateFloat(estimatedQuantity)
              : false
        ) {
          ctx.addIssue({
            code: 'too_small',
            minimum: 1,
            inclusive: false,
            type: 'string',
            path: [`optionsAttributes[${i}].estimatedQuantity`],
            message: `estimated.required.${valueType}`,
          });
        }
        if (!final) return;
        if (valueType === 'text' ? !finalQuantity : !validateFloat(finalQuantity)) {
          ctx.addIssue({
            code: 'too_small',
            minimum: 1,
            inclusive: false,
            type: 'string',
            path: [`optionsAttributes[${i}].finalQuantity`],
            message: `final.required.${valueType}`,
          });
        }
      },
    );
  });

export const defaultValues: MaterialMeasurementFormValues = {
  final: false,
  optionsAttributes: [],
};
